if (!customElements.get('wala-card-buy')) {
  customElements.define('wala-card-buy', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.form = this.querySelector('form');
      this.select = this.querySelector('select');
      this.button = this.querySelector('button');
      this.status = this.querySelector('[role="status"]');
      this.addEventListener('click', event => event.stopPropagation());
      this.select.addEventListener('change', () => this.refresh());
      this.form.addEventListener('submit', event => this.add(event));
      this.refresh();
    }
    refresh() {
      const option = this.select.selectedOptions[0];
      const available = option?.dataset.available === 'true';
      this.querySelector('[data-buy-price]').textContent = option?.dataset.price || '';
      this.button.disabled = this.busy || !available;
      this.button.textContent = this.busy ? this.dataset.adding : available ? this.dataset.add : this.dataset.soldOut;
    }
    async add(event) {
      event.preventDefault();
      event.stopPropagation();
      if (this.busy || this.button.disabled) return;
      const id = this.select.value;
      if (!/^\d+$/.test(id)) return;
      this.busy = true;
      this.status.textContent = '';
      this.refresh();
      try {
        const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
        });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || result.message || this.dataset.error);
        window.location.assign(this.dataset.cartUrl);
      } catch (error) {
        this.status.textContent = error.message || this.dataset.error;
        this.busy = false;
        this.refresh();
      }
    }
  });
}
